import { createFileRoute } from '@tanstack/react-router'
import { SignupApplicationsPage } from '@/features/admin/signup-applications'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/signup-applications/')({
  component: SignupApplicationsPage,
  beforeLoad: requireRole(['admin']),
})
